import * as React from 'react';
import I18N from 'src/services/I18NService';
import { IMallPricePolicy } from 'src/entity/MallEntity';

interface IPriceModelProps {
  info: IMallPricePolicy;
}

class PriceModelComponent extends React.Component<IPriceModelProps> {
  constructor(props: IPriceModelProps) {
    super(props);
  }

  render() {
    return (
      <div className="price-model-box">
        <div className="price-model-name">
          <span>{this.props.info.name}</span>
        </div>

        <div className="price-model-rate">
          {I18N.get('common_discount_rate')}: {this.props.info.ratio}%
        </div>
      </div>
    );
  }
}

export default PriceModelComponent;



// WEBPACK FOOTER //
// ./src/components/views/Mall/PriceModelComponent.tsx